module.exports = __webpack_public_path__ + "img/wh-shape-2.77ee6652.png";